
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.484 7.03v3.125l1.63 1.876","stroke":"#999","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"9.999","cy":"10","r":"6.667","stroke":"#999","stroke-width":"2"}})])
          )
        }
      }
    